import { IResponse } from "models";

export enum ActionType {
  FULL_STRESS_SCORING = "action/FULL_STRESS_SCORING",
  FULL_STRESS_SCORING_SUCCESS = "action/FULL_STRESS_SCORING_SUCCESS",
  FULL_STRESS_SCORING_ERROR = "action/FULL_STRESS_SCORING_ERROR",
  FULL_STRESS_SCORING_RESET = "action/FULL_STRESS_SCORING_RESET",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

interface IStressItem {
  name: string;
  low: boolean;
  slightly_low: boolean;
  normal: boolean;
  slightly_high: boolean;
  high: boolean;
  rating_point: number;
}

export interface IFullStressScoringPayload {
  stress_check_id: string;
}

export interface IFullStressScoring {
  user_information?: {
    name: string;
    designation: string;
    age: string;
    gender: string;
    stress_assessment_result: string;
  };
  point_information?: {
    stress_factor: number;
    mental_physical: number;
    cause_of_stress: number;
    total: number;
  };
  stress_results?: {
    group1?: {
      order_5_to_1: IStressItem[];
      order_1_to_5: IStressItem[];
    };
    group2?: {
      order_5_to_1: IStressItem[];
      order_1_to_5: IStressItem[];
    };
    group3?: {
      order_1_to_5: IStressItem[];
    };
  };
}

export interface IFullStressScoringResponse extends IResponse {
  result: IFullStressScoring;
}
